import script from "./Cadastros.vue?vue&type=script&setup=true&lang=js"
export * from "./Cadastros.vue?vue&type=script&setup=true&lang=js"

import "./Cadastros.vue?vue&type=style&index=0&id=cdf06670&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdf06670"]])

export default __exports__